import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ArizonaLocalAssociations } from './pages/ArizonaLocalAssociations';
import { LinksAndResources } from './pages/LinksAndResources';
import { PrivacyStatement } from './pages/PrivacyStatement';
import { RefundPolicy } from './pages/RefundPolicy';
import { LostCertificates } from './pages/LostCertificates';
import { FAQs } from './pages/FAQs';
import { RecoverPassword } from './pages/RecoverPassword';
import { ContactUs } from './pages/ContactUs';
import { About } from './pages/About';
import { Instructors } from './pages/Instructors';
import { Blog } from './pages/Blog';
import { LicenseInformation } from './pages/LicenseInformation';
import { HowToAddCEClasses } from './pages/HowToAddCEClasses';
import { OnlineClasses } from './pages/OnlineClasses';
import { LiveClasses } from './pages/LiveClasses';
import { LoginRegister } from './pages/LoginRegister';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { LiveChatButton } from './components/LiveChatButton';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/Arizona_Local_Associations" element={<ArizonaLocalAssociations data-id="element-7" />} data-id="element-6" />
          <Route path="/Links&Resources" element={<LinksAndResources data-id="element-9" />} data-id="element-8" />
          <Route path="/15.html" element={<PrivacyStatement data-id="element-11" />} data-id="element-10" />
          <Route path="/45.html" element={<RefundPolicy data-id="element-13" />} data-id="element-12" />
          <Route path="/11.html" element={<LostCertificates data-id="element-15" />} data-id="element-14" />
          <Route path="/16.html" element={<FAQs data-id="element-17" />} data-id="element-16" />
          <Route path="/14.html" element={<RecoverPassword data-id="element-19" />} data-id="element-18" />
          <Route path="/Contact" element={<ContactUs data-id="element-21" />} data-id="element-20" />
          <Route path="/About" element={<About data-id="element-23" />} data-id="element-22" />
          <Route path="/Instructors" element={<Instructors data-id="element-25" />} data-id="element-24" />
          <Route path="/Blog" element={<Blog data-id="element-27" />} data-id="element-26" />
          <Route path="/License_Information" element={<LicenseInformation data-id="element-29" />} data-id="element-28" />
          <Route path="/How_To_Add_CE_Classes" element={<HowToAddCEClasses data-id="element-31" />} data-id="element-30" />
          <Route path="/Products" element={<OnlineClasses data-id="element-33" />} data-id="element-32" />
          <Route path="/LiveClasses.html" element={<LiveClasses data-id="element-35" />} data-id="element-34" />
          <Route path="/login-register" element={<LoginRegister data-id="element-37" />} data-id="element-36" />
        </Routes>
        <Footer data-id="element-38" />
        <LiveChatButton data-id="element-39" />
      </div>
    </BrowserRouter>;
}